import React, { useEffect, useState } from "react";
import { getExecutiveVotes, getSenateVotes } from "../../Sevices/api-requests";
import MaterialTable from "material-table";
import { forwardRef } from "react";
import { Grid } from "@material-ui/core";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: "10%",
    [theme.breakpoints.down("xs")]: {
      //height: "30vh",
      maxWidth: "80%",
      marginLeft: "10%",
    },
    [theme.breakpoints.up("md")]: {
      //height: "35vh",
      maxWidth: "50%",
      marginLeft: "25vw",
      // marginRight:"2%"
    },
  },
  media: {
    height: 280,
  },
}));
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const ResultPage = ({ user }) => {
  const [excos, setExcos] = useState([]);
  const [first, setFirst] = useState([]);
  const [sec, setSec] = useState([]);
  const [third, setThird] = useState([]);
  const [fourth, setFourth] = useState([]);
  const [fifth, setFifth] = useState([]);
  useEffect(() => {
    GetResults();
  }, []);

  const GetResults = () => {
    getExecutiveVotes("any").then((result) => {
      setExcos(result.data.data);
      getSenateVotes(200).then((seco) => {
        setSec(seco.data.data);
      });
      getSenateVotes(300).then((thir) => {
        setThird(thir.data.data);
      });
      getSenateVotes(500).then((fif) => {
        setFifth(fif.data.data);
      });
      getSenateVotes(100).then((sixi) => {
        setFirst(sixi.data.data);
      });
      getSenateVotes(400).then((four) => {
        setFourth(four.data.data);
      });
    });
  };
  const classes = useStyles();

  return (
    <>
      {/* {true ?  */}
      {user.matricNo === "220998" || user.matricNo === "213122" ? (
        <Grid
          container
          alignContent="center"
          justifyContent="center"
          className={classes.table}
        >
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Total Yes", field: "yes", type: "numeric" },
              { title: "Total No", field: "no" },
              { title: "Yes in 100 Level", field: "yes_100" },
              { title: "No in 100 Level", field: "no_100" },
              { title: "Yes in 200 Level", field: "yes_200" },
              { title: "No in 200 Level", field: "no_200" },
              { title: "Yes in 300 Level", field: "yes_300" },
              { title: "No in 300 Level", field: "no_300" },
              { title: "Yes in 400 Level", field: "yes_400" },
              { title: "No in 400 Level", field: "no_400" },
              { title: "Yes in 500 Level", field: "yes_500" },
              { title: "No in 500 Level", field: "no_500" },
              { title: "Yes in 600 Level", field: "yes_600" },
              { title: "No in 600 Level", field: "no_600" },
            ]}
            data={[...excos]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="Executive Result"
          />

          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Yes", field: "yes", type: "numeric" },
              { title: "No", field: "no" },
            ]}
            data={[...first]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="100 Senate Result"
          />

          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Yes", field: "yes", type: "numeric" },
              { title: "No", field: "no" },
            ]}
            data={[...sec]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="200 Senate Result"
          />
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Yes", field: "yes", type: "numeric" },
              { title: "No", field: "no" },
            ]}
            data={[...third]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="300 Senate Result"
          />
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Yes", field: "yes", type: "numeric" },
              { title: "No", field: "no" },
            ]}
            data={[...fourth]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="400 Senate Result"
          />
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Name", field: "_id" },
              { title: "Position", field: "position" },
              { title: "Yes", field: "yes", type: "numeric" },
              { title: "No", field: "no" },
            ]}
            data={[...fifth]}
            options={{
              exportButton: true,
              headerStyle: {
                backgroundColor: "#01579b",
                color: "#FFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
              },
            }}
            title="500 Senate Result"
          />
        </Grid>
      ) : (
        <p style={{ padding: "2rem" }}>
          Dey Play, You don't have access to this Page. Go back to where you are
          coming from
        </p>
      )}
    </>
  );
};

export default ResultPage;
